// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import echarts from "echarts";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import infiniteScroll from "vue-infinite-scroll";
import moment from "moment";
import "moment/locale/zh-cn";
//解决本地调用跨域问题
// Vue.prototype.$axios = axios;
// // 设置请求url前缀
// axios.defaults.baseURL = "/api";
// axios.defaults.headers.post["Content-Type"] = "application/json";
//解决本地调用跨域问题
Vue.prototype.$echarts = echarts;
// 定义外部接口可配置
let startApp = function() {
  axios.get(`/static/config.json?random=${new Date().getTime()}`).then(res => {
    // 基础地址
    Vue.prototype.baseUrl = res.data.baseUrl;
    // Vue.prototype.$baseUrl = res.data.baseUrl;
    // Vue.prototype.BASE_URL = res.data.baseUrl;
    console.log(res, "res");
    // 解决多次刷新找不到config中的内容的的情况
    new Vue({
      el: "#app",
      router,
      components: { App },
      template: "<App/>"
    });
  });
};
startApp();
Vue.use(ElementUI);

Vue.use(infiniteScroll);

//定义一个全局过滤器实现日期格式化
Vue.prototype.$moment = moment;
// $moment(scope.row.dateline).format('YYYY-MM-DD HH:mm:ss')

// axios.defaults.withCredentials = true;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

/* eslint-disable no-new */



// WEBPACK FOOTER //
// ./src/main.js